import { render, staticRenderFns } from "./OldNewDialogV2.vue?vue&type=template&id=5abccbd0&scoped=true"
import script from "./OldNewDialogV2.vue?vue&type=script&lang=js"
export * from "./OldNewDialogV2.vue?vue&type=script&lang=js"
import style0 from "./OldNewDialogV2.vue?vue&type=style&index=0&id=5abccbd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abccbd0",
  null
  
)

export default component.exports